import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  page: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  languageBar: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(3, 3, 0),
    maxWidth: "100%",
  },
  emailContainer: {
    padding: theme.spacing(3),
    width: "600px",
    height: "100%",
    background: theme.palette.emailBackground.main,
  },
  poweredByContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(45),
  },
  loader: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
  },
}));
